<template>
  <div class="landing-page">
    <LandingPageStepHeader class="landing-page-hero">
      <div class="container">
        <h1 class="landing-page-hero__heading">An Easier Way to Get a Car</h1>
        <p class="landing-page-hero__subheading">
          No Appointments, No Obligation and Free to Apply
        </p>
      </div>

      <div class="landing-page-hero__bg-container container">
        <div class="landing-page-hero__bg"/>
      </div>

      <div class="container">

        <div class="landing-page-hero__cta">
          <div class="landing-page-hero__cta-text">Are you looking for a new or used vehicle?</div>
          <div class="landing-page-hero__buttons">
            <AppButtonContinue
              v-for="(button, index) in buttons"
              :key="index"
              class="landing-page-hero__button"
              @click="handleClick(button.text)"
            >
              {{ button.text }}
            </AppButtonContinue>
          </div>
        </div>
        <div class="landing-page-hero__tooltip">
          <small>
            We have $0 down options available, making it even easier for you to get the car you want.
          </small>
        </div>
      </div>
    </LandingPageStepHeader>

    <SmartBuyCar/>

    <InventoryCards
      @inventory-card-click="handleInventoryCardClick"
    />

    <TraditionalVsCd />

    <GetApprovedCTA
      @cta-click="$emit('next')"
    />
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import DataLayer from '@/data-layer'
import GetApprovedCTA from './GetApprovedCTA'
import LandingPageStepHeader from './LandingPageStepHeader'
import SmartBuyCar from './SmartBuyCar'
import InventoryCards from './InventoryCards'
import TraditionalVsCd from './TraditionalVsCd'

export default {
  name: 'landing-page',

  components: {
    AppButtonContinue,
    LandingPageStepHeader,
    GetApprovedCTA,
    SmartBuyCar,
    InventoryCards,
    TraditionalVsCd
  },

  data () {
    return {
      buttons: [{
        text: 'New'
      }, {
        text: 'Used'
      }]
    }
  },

  methods: {
    handleClick (newOrUsed) {
      this.$store.state.vehicleUsed = newOrUsed === 'Used'
      DataLayer.track({ event: 'gpa_clicked', source_page: this.$route.fullPath, cta_position: 'Hero' })
      this.$emit('next')
    },

    handleInventoryCardClick () {
      DataLayer.track({ event: 'gpa_clicked', source_page: this.$route.fullPath, cta_position: 'Inventory Card' })
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss" scoped>
$light-blue: #3FF6FE;
$dark-blue: #22C8F9;
$imagePath: '../../../../../assets/img/landing-page/blue-wave-bg/';

.cta-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;

  @include breakpoint('tablet-portrait-up') {
    padding: 0 40px;
  }
  @media (min-width: 768px) {
    display: flex;
  }
  @include breakpoint('desktop-up') {
    padding: 0;
  }

  @media (min-width: 768px) {
    > div {
      width: 50%;
    }
    > div:first-child {
      padding-right: 5px;
    }

    > div:last-child {
      padding-left: 5px;
    }
  }

  @media (min-width: 1024px) {
    > div:first-child {
      padding-right: 55px;
    }

    > div:last-child {
      padding-left: 55px;
    }
  }

  @include breakpoint('desktop-up') {
    > div:first-child {
      padding-right: 20px;
    }

    > div:last-child {
      padding-left: 20px;
    }
  }
}

.landing-page.step-component {
  padding-top: 0;
}

.landing-page-hero {
  position: relative;
  margin-bottom: 10px;
  top: -105px;
  padding-bottom: 0;

  @include breakpoint('tablet-portrait-up') {
    margin-bottom: 0px;
  }

  @include breakpoint('tablet-landscape-up') {
    margin-bottom: 110px;
  }

  &__bg-container {
    padding: 0;

    @include breakpoint('mobile-only') {
      margin-top: -30px;
    }

    @include breakpoint('desktop-up') {
      position: relative;
    }
  }

  &__bg {
    position: relative;
    width: 100%;
    padding-top: 59.17%; /** Aspect Ratio for full width mobile image + height */
    z-index: -1;
    background-size: cover;
    background-repeat: no-repeat;
    background-size: 100%;
    background-image: url(#{$imagePath}/hero-mobile-new.jpg);

    @include breakpoint('tablet-portrait-up') {
      top: 0;
      padding-top: 0;
      position: absolute;
      background-image: url(#{$imagePath}/hero-desktop.jpg);
      height: 560px;
      left: 290px;
      background-size: auto 560px;
    }

    @include breakpoint('tablet-landscape-up') {
      left: 370px;
      background-size: auto 768px;
      height: 768px;
    }

    @include breakpoint('desktop-up') {
      top: -401px;
      left: 500px;
    }

    @include breakpoint('desktop-large-up') {
      width: 100vw;
      left: 440px;
    }
  }

  &__heading {
    margin-bottom: 10px;
    margin-top: 60px;
    text-align: center;
    line-height: 1.3;

    @include breakpoint('mobile-large-up') {
      font-size: 36px;
    }

    @include breakpoint('tablet-portrait-up') {
      text-align: left;
      margin-top: 60px;
      width: 245px;
    }

    @include breakpoint('tablet-landscape-up') {
      font-size: 50px;
      line-height: 60px;
      margin-top: 120px;
      margin-bottom: 10px;
      width: 340px;
    }

    @include breakpoint('desktop-up') {
      width: 460px;
    }
  }

  &__subheading {
    font-weight: 600;
    margin-top: 0px;
    text-align: center;
    max-width: 280px;
    margin-left: auto;
    margin-right: auto;

    @include breakpoint('tablet-portrait-up') {
      font-size: 17px;
      text-align: left;
      margin-bottom: 50px;
      margin-left: initial;
      margin-right: initial;
      width: 260px;
    }

    @include breakpoint('tablet-landscape-up') {
      margin-bottom: 85px;
      width: 360px;
    }

    @include breakpoint('desktop-up') {
      font-weight: 600;
      margin-bottom: 95px;
      margin-top: 5px;
      max-width: initial;
      width: auto;
    }
  }

  &__cta-text {
    font-weight: 600;
    font-size: 17px;
    line-height: 1.5;
    text-align: center;
    width: 180px;
    margin: 0 auto 20px auto;

    @include breakpoint('tablet-portrait-up') {
      margin: 0 auto 30px auto;
      text-align: left;
      margin-left: 0;
      width: 180px;
    }

    @include breakpoint('tablet-landscape-up') {
      margin: 0 0 25px 0;
      width: 100%;
    }

    @include breakpoint('desktop-up') {
      width: 355px;
    }
  }

  &__buttons {
    display: flex;

    @include breakpoint('mobile-large-up') {
      justify-content: center;
    }

    @include breakpoint('tablet-portrait-up') {
      width: 355px;
      justify-content: flex-start;
    }
  }

  &__button {
    width: 50%;
    &:first-of-type {
      margin-right: 15px;
    }

    @include breakpoint('mobile-large-up') {
      max-width: 150px;
    }

    @include breakpoint('tablet-portrait-up') {
      font-size: 19px;
      max-width: 125px;
      padding: 11px 0;
      margin-right: 15px;
    }

    @include breakpoint('tablet-landscape-up') {
      padding: 16px 0;
      max-width: 165px;
      margin-right: 25px;
      color: #FFFFFF;
    }
  }

  &__tooltip {
    margin: 15px 0;
    text-align: center;

    @include breakpoint('mobile-large-up') {
      max-width: 265px;
      margin: 20px auto;
    }

    @include breakpoint('tablet-portrait-up') {
      text-align: left;
      margin: 30px 0;
      max-width: 260px;
    }

    @include breakpoint('tablet-landscape-up') {
      max-width: 355px;
    }

    small {
      font-size: 12px;
      @include breakpoint('tablet-portrait-up') {
        font-size: 14px;
      }
    }
  }
}
.application .landing-page .trustpilot {
  width: 95%;
  max-width: 1100px;
  min-height: 300px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 60px;
  font-weight: 600;
  @include breakpoint('tablet-portrait-up') {
    width: 92%;
  }
  @include breakpoint('tablet-landscape-up') {
    width: 95%;
  }
  @include breakpoint('desktop-up') {
    width: 100%;
    margin-top: 100px;
  }

  :deep() .trustpilot__title {
    font-family: $font-family-title;
    font-size: 24px;
    line-height: 30px;
    @include breakpoint('tablet-portrait-up') {
      font-size: 36px;
      line-height: 40px;
    }
  }

  :deep() .trustpilot-widget iframe {
    left: -5px;
    @media screen and (min-width: 350px) {
      left: 0;
    }
  }
}
</style>
